import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=67f4aa8c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f4aa8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f4aa8c')) {
      api.createRecord('67f4aa8c', component.options)
    } else {
      api.reload('67f4aa8c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=67f4aa8c&scoped=true&", function () {
      api.rerender('67f4aa8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20tqdQE6k5XFX/JS/comp/Accordion.vue"
export default component.exports